import { clsx } from 'clsx';
import { Content } from 'src/contexts/ContentContext';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { InfoOutlineIcon, WarningOutlineIcon } from 'src/svgs/Viagogo';
import { EVENT_STATUS_TO_CID } from 'src/utils/constants/contentIdMaps';
import { ApiEventStatus } from 'src/WebApiController';

import {
  EventStatusProps,
  EventStatusToColor,
  StatusColor,
} from './EventStatus.type';
import * as styles from './EventStatusBanner.css';

export const EventStatusBanner = ({ status }: EventStatusProps) => {
  // Don't show normal state
  if (!status || status === ApiEventStatus.Normal) {
    return null;
  }

  const colorStat = EventStatusToColor[status];
  return (
    <Stack
      className={clsx(
        styles.eventStatusBannerWrapper,
        styles.eventStatusBannerBorder[colorStat]
      )}
      direction="row"
      alignItems="center"
      justifyContent="center"
      gap="m"
    >
      <Stack alignItems="center" justifyContent="center">
        {colorStat === StatusColor.Gray ? (
          <InfoOutlineIcon fill="inherit" size={vars.iconSize.m} />
        ) : (
          <WarningOutlineIcon fill="inherit" size={vars.iconSize.m} />
        )}
      </Stack>
      <span className={styles.eventStatusBannerColor[colorStat]}>
        <Content id={EVENT_STATUS_TO_CID[status]} />
      </span>
    </Stack>
  );
};
